if (!customElements.get('quantity-selector')) {
  customElements.define(
    'quantity-selector',
    class QuantitySelector extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setEventListeners();
        this.setDefaultState();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          decrement: this.querySelector('[js-quantity-selector="decrement"]'),
          increment: this.querySelector('[js-quantity-selector="increment"]'),
          input: this.querySelector('[js-quantity-selector="input"]'),
        };
      }

      /**
       * Set event handlers.
       */
      setEventListeners() {
        if (this.nodeSelectors.decrement) {
          this.nodeSelectors.decrement.addEventListener('click', this.decrement.bind(this));
        }

        if (this.nodeSelectors.increment) {
          this.nodeSelectors.increment.addEventListener('click', this.increment.bind(this));
        }

        if (this.nodeSelectors.input) {
          this.nodeSelectors.input.addEventListener('change', this.handleInputChange.bind(this));
        }
      }

      /**
       * Decreases the quantity input.
       */
      decrement() {
        if (
          !this.nodeSelectors.input ||
          parseInt(this.nodeSelectors.input.min) === parseInt(this.nodeSelectors.input.value)
        ) {
          return;
        }

        this.nodeSelectors.input.value = parseInt(this.nodeSelectors.input.value) - 1;

        this.emitChange();
      }

      /**
       * Increases the quantity input.
       */
      increment() {
        if (
          !this.nodeSelectors.input ||
          parseInt(this.nodeSelectors.input.max) === parseInt(this.nodeSelectors.input.value)
        ) {
          return;
        }

        this.nodeSelectors.input.value = parseInt(this.nodeSelectors.input.value) + 1;

        this.emitChange();
      }

      /**
       * Emits the change event on the input.
       */
      emitChange() {
        if (!this.nodeSelectors.input) {
          return;
        }

        this.nodeSelectors.input.dispatchEvent(new Event('change'));
      }

      /**
       * Handles the quantity input change event.
       */
      handleInputChange(event) {
        this.setDefaultState(event.currentTarget);
      }

      /**
       * Sets the quantity selector default state.
       * @param {HTMLInputElement} input - The input element.
       */
      setDefaultState(input = this.nodeSelectors.input) {
        const value = parseInt(input.value);
        const min = parseInt(input.min);
        const className = 'quantity-selector__button--remove';

        if (this.hasAttribute('show-remove-icon') && this.nodeSelectors.decrement) {
          if (value === min || (min === 0 && value === 1)) {
            this.nodeSelectors.decrement.classList.add(className);
            return;
          }

          this.nodeSelectors.decrement.classList.remove(className);
        }
      }
    }
  );
}
